import { jwtDecode } from "jwt-decode";
import { AuthTokenPayload } from "modules/user/infrastructure/repository/auth/authSlice";

export function isTokenExpired(token: string): boolean {
  const decodedToken = jwtDecode<AuthTokenPayload>(token);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp < currentTime;
}
